














import { Vue, Component, Prop } from 'vue-property-decorator';
import Spinner from '~/patterns/atoms/spinner/spinner.vue';

@Component({
    components: { Spinner },

    watch: {
        loading: {
            immediate: true,
            handler: function(this: Filterable, newValue) {
                if (this.$refs.container) {
                    const height = (this.$refs.container as Element).clientHeight;
                    if (newValue === true) {
                        // Preserve current height while loading
                        this.height = height;
                    } else {
                        // Set new height after render update
                        this.$nextTick(() => {
                            if (this.hasItems) {
                                this.height = (this.$refs.container as Element).clientHeight;
                            } else {
                                this.height = (this.$refs.noItems as Element).clientHeight;
                            }
                        });
                    }
                }
            }
        }
    }
})
export default class Filterable extends Vue {
    @Prop() loading!: boolean;
    @Prop() hasItems!: boolean;
    @Prop() name!: string;
    height: number = 528; // initial height of spinner / 'no items' element

    get computedHeight(): string {
        if (this.height <= 0) {
            return 'height: auto';
        }
        return `height: ${this.height}px;`;
    }
}
